import React from "react";
import { getLiveness, getReadiness } from "../services/backend/healthService";

const Health = () => {
  const readiness = getReadiness();
  const liveness = getLiveness();
  return (
    <div style={{ padding: 16, fontFamily: "sans-serif" }}>
      <div>Status: OK</div>
      <div>Time: {new Date().toISOString()}</div>
      <div>Version: 1.0.0</div>
      <div>Readiness: {readiness.status}</div>
      <div>Liveness: {liveness.status}</div>
    </div>
  );
};

export default Health;
